import styled from 'styled-components';

export const NewsletterErrorMsg = styled.span`
    color: ${props => props.theme.colors.red80};
    font-size: 0.75em;
`;
